export { default } from './FeatureContent';
